module.exports = {
    scssVariables: './src/styles/SYNSTORESARG',
    defaultLanguage: 'es',
    profileColor: {saturation: 90, brightness: 80},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}